import { render, staticRenderFns } from "./WjEdit1.vue?vue&type=template&id=115e0c7c&scoped=true&"
import script from "./WjEdit1.vue?vue&type=script&lang=js&"
export * from "./WjEdit1.vue?vue&type=script&lang=js&"
import style0 from "./WjEdit1.vue?vue&type=style&index=0&id=115e0c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e0c7c",
  null
  
)

export default component.exports